export const emailCampaignCopy = {
  errors: {
    acceptedTerms:
      'Confirm that you have read and understood the information above',
    cannotSave: 'We couldn’t save your campaign. Try again later.',
    cannotSchedule: 'We couldn’t schedule your campaign. Try again later.',
    futureDate:
      'The selected time is in the past, select a future date and time to proceed',
    noSubscription:
      "To schedule a campaign, you'll need an active subscription. Go to Settings > Billing & Payments to update your plan."
  },
  labels: {
    date: 'Start date',
    time: 'Send time',
    maxSend:
      "What's the maximum number of fans you've emailed in a day in the last 14 days?",
    checkbox:
      'I understand the risk and want to send the email to all selected fans at once'
  },
  placeholders: {
    date: 'Select a date',
    timezone: 'Select timezone'
  }
}
